import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import { EntityOrderedRequestParameters, EntityPagedRequestParameters, EntityPagedResult } from '@bndes/bndes-ux4/bndes-angular-utils';
import { JanelaSolicitacaoHonra } from 'src/app/model/janela-solicitacao-honra.model';

@Component({
  selector: 'app-janela-solicitacao-honra-listagem',
  templateUrl: './janela-solicitacao-honra-listagem.component.html',
  styleUrl: './janela-solicitacao-honra-listagem.component.scss',
  standalone: false,
})
export class JanelaSolicitacaoHonraListagemComponent implements OnInit{
  private readonly DIA_FECHAMENTO_MAXIMO = 20;
  private readonly DIA_FECHAMENTO_PADRAO = 15;

  public janelas = input<JanelaSolicitacaoHonra[]>([]);
  public atributosPaginacao = input<EntityPagedResult<JanelaSolicitacaoHonra>>();
  public opcoesPaginacao = input<number[]>();
  public dataSistema = input<Date>(new Date());

  public aoMudarPagina = output<EntityPagedRequestParameters>();
  public aoPedirExtensao = output<JanelaSolicitacaoHonra>();

  public atributosOrdenacao = signal<EntityOrderedRequestParameters>(null);
  public janelasOrdenadas = computed(() => this.pesquisarOrdenacao());
  private atributosData = ['nomeJanela', 'dataAbertura', 'dataFechamento', 'dataInicioProcessamento'];

  ngOnInit(): void {
    this.atributosOrdenacao.set({
      atributo: 'dataAbertura',
      sentido: 'asc',
    });
  }

  estender(janela: JanelaSolicitacaoHonra) {
    if (this.podeEstender(janela)) {
      this.aoPedirExtensao.emit(janela);
    }
  }

  mudarTamanhoPagina(novoTamanho: number): void {
    const novosAtributos: EntityPagedRequestParameters = {
      page: this.atributosPaginacao().page,
      pageSize: novoTamanho
    }
    this.aoMudarPagina.emit(novosAtributos);
  }

  mudarNumeroPagina(novoNumero: number): void {
    const novosAtributos: EntityPagedRequestParameters = {
      page: novoNumero,
      pageSize: this.atributosPaginacao().pageSize
    }
    this.aoMudarPagina.emit(novosAtributos);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters): void {
    this.atributosOrdenacao.set(novaOrdenacao);
  }

  podeEstender(janela: JanelaSolicitacaoHonra): boolean {
    if (!this.dataSistema())
      return false;
    
    const dataReferencia = janela.dataFechamento ?? janela.dataAbertura;

    if (!dataReferencia || !this.mesAtual(dataReferencia)) 
      return false;

    const diaFechamento = janela.dataFechamento?.getDate() ?? this.DIA_FECHAMENTO_PADRAO;
    
    return (
      this.dataSistema().getDate() <= diaFechamento &&
      diaFechamento < this.DIA_FECHAMENTO_MAXIMO
    );
  }

  mesAtual(data: Date): boolean {
    return (
      data.getMonth() === this.dataSistema().getMonth() &&
      data.getFullYear() === this.dataSistema().getFullYear()
    );
}

  pesquisarOrdenacao() {
    const campo = this.atributosOrdenacao().atributo;
    const sentido = this.atributosOrdenacao().sentido === 'asc' ? 1 : -1;

    const a = [...this.janelas().sort((a, b) => {
      let valA = a[campo];
      let valB = b[campo];
      
      if (valA == null) return 1;
      if (valB == null) return -1;

      if (this.atributosData.includes(campo)) {
        valA = this.tranfomarData(valA);
        valB = this.tranfomarData(valB);
      }
      
      if (typeof valA === 'string' && typeof valB === 'string') {
        return valA.localeCompare(valB) * sentido;
      }

      if (valA < valB) return -1 * sentido;
      if (valA > valB) return  1 * sentido;

      return 0;
    })];
    return a;
  }

  tranfomarData(dataStr: string): Date | null {
    const regexAnoMesDia = /^\d{4}-\d{2}-\d{2}$/;
    if (regexAnoMesDia.test(dataStr)) 
      return new Date(dataStr);

    const regexMesAno = /^\d{2}\/\d{4}$/;
    if (regexMesAno.test(dataStr)) {
      const dataSeparada = dataStr.split('/');
      return new Date(`${dataSeparada[1]}-${dataSeparada[0]}-01`);
    }

    return null;
  }
}
